"use client";

import { useEffect, useState } from "react";
import { useResolvedDarkMode } from "@/lib/theme/use-resolved-dark";

/** Внутренняя обёртка Puck (LandingCmsTheme), не статичный shell шапки/футера. */
function readLandingResolvedDark(): boolean | null {
  if (typeof document === "undefined") return null;
  const roots = document.querySelectorAll(
    ".landing-cms-theme[data-landing-resolved]",
  );
  if (!roots.length) return null;
  const root = roots[roots.length - 1]!;
  return root.getAttribute("data-landing-resolved") === "dark";
}

/** Тёмная тема: переключатель сайта + data-landing-resolved на Puck-обёртке. */
export function useLandingResolvedDark(): boolean {
  const appDark = useResolvedDarkMode();
  const [landingDark, setLandingDark] = useState<boolean | null>(null);

  useEffect(() => {
    const sync = () => setLandingDark(readLandingResolvedDark());
    sync();

    const observer = new MutationObserver(sync);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
      subtree: true,
    });
    document.querySelectorAll(".landing-cms-theme").forEach((el) => {
      observer.observe(el, {
        attributes: true,
        attributeFilter: ["data-landing-resolved", "data-theme"],
      });
    });

    return () => observer.disconnect();
  }, []);

  if (appDark) return true;
  if (landingDark !== null) return landingDark;
  return false;
}
